import Modal from "react-modal";
import React from "react";
import * as S from "./styles";

interface ModalProps {
  title: string;
  content: string;
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  accept: React.MouseEventHandler<HTMLButtonElement>;
  deny: React.MouseEventHandler<HTMLButtonElement>;
}

Modal.setAppElement("#root");
export default function ApprovalPicsModal({
  title,
  modalIsOpen,
  setIsOpen,
  accept,
  deny,
  content,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.ActiveModalContent {...props}>{children}</S.ActiveModalContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ActiveModalOverlay {...props}>{contentElement}</S.ActiveModalOverlay>
      )}
    >
      <S.ModalContent>
        <h2>{title}?</h2>
        <p>{content}</p>
        <S.ActiveButtonContainer>
          <S.ActiveConfirmButton onClick={accept}>
            Aceitar
          </S.ActiveConfirmButton>
          <S.ActiveCloseButton onClick={deny}>Negar</S.ActiveCloseButton>
        </S.ActiveButtonContainer>
      </S.ModalContent>
    </Modal>
  );
}
